import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type {
  IntegrationStatusViewState,
  PartnerIntegrationStatusPagination,
} from "./Types";
import type { IntegrationTableColumn } from "./integrationStatusColumns";
import type {
  IntegrationPartnerRow,
  IntegrationPlatformCard,
  IntegrationSummaryTile,
} from "../../../pages/hid-admin/dashboard/partner-organizations/partner-list/integration-status/integrationStatusTypes";

type IntegrationStatusState = IntegrationStatusViewState & {
  status: {
    loading: boolean;
    exportLoading: boolean;
    error: string | null;
  };
};

const initialState: IntegrationStatusState = {
  summaryTiles: [],
  platformCards: [],
  tableColumns: [],
  partners: [],
  pagination: null,
  status: {
    loading: false,
    exportLoading: false,
    error: null,
  },
};

const integrationStatusSlice = createSlice({
  name: "integration_status",
  initialState,
  reducers: {
    setIntegrationStatusLoading: (state, action: PayloadAction<boolean>) => {
      state.status.loading = action.payload;
    },
    setIntegrationStatusExportLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.status.exportLoading = action.payload;
    },
    setIntegrationStatusError: (state, action: PayloadAction<string | null>) => {
      state.status.error = action.payload;
    },
    setIntegrationStatusData: (
      state,
      action: PayloadAction<{
        summaryTiles: IntegrationSummaryTile[];
        platformCards: IntegrationPlatformCard[];
        tableColumns: IntegrationTableColumn[];
        partners: IntegrationPartnerRow[];
        pagination: PartnerIntegrationStatusPagination;
      }>
    ) => {
      state.summaryTiles = action.payload.summaryTiles;
      state.platformCards = action.payload.platformCards;
      state.tableColumns = action.payload.tableColumns;
      state.partners = action.payload.partners;
      state.pagination = action.payload.pagination;
      state.status.error = null;
    },
    clearIntegrationStatusData: (state) => {
      state.summaryTiles = [];
      state.platformCards = [];
      state.tableColumns = [];
      state.partners = [];
      state.pagination = null;
    },
  },
});

export const integrationStatusSliceReducer = integrationStatusSlice.reducer;
export const integrationStatusSliceAction = integrationStatusSlice.actions;
